import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cn } from '@repo/ui/utils'
import * as React from 'react'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'border-primary-200 text-primary-950 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-primary-800 dark:bg-primary-950 dark:text-primary-50 z-50 overflow-hidden rounded-md border bg-white px-3 py-1.5 text-sm shadow-md',
      className,
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

const TooltipWrapper = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    disabled?: boolean
  }
>(({ className, children, content, ...props }, ref) => {
  const core = <div ref={ref}>{children}</div>
  if (props.disabled) return <>{core}</>
  return (
    <TooltipProvider>
      <Tooltip {...props}>
        <TooltipTrigger asChild>{core}</TooltipTrigger>
        <TooltipContent
          side={props.side}
          sideOffset={props.sideOffset}
          align={props.align}
          className="select-none"
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
})

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, TooltipWrapper }
